import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import { message, Select as AntdSelect } from "antd";
import moment from "moment";
import _ from "lodash";
import actions from "@redux/equipmentCategory/actions";
import {connect} from "react-redux";
import {api} from "@redux/api";
import { useAuth, AUTH_LEVEL } from '@/hooks/use-auth';
import { useSmartNavigate } from '@/hooks/use-smart-navigate';
import Modal from "@components/ResponsiveModal";
import Select from "@components/ResponsiveSelect";
import {
    Equipment_CategoryColumns,
    Equipment_CategoryProps
} from "@containers/facility/Equipment_Category/Equipment_CategoryColumns";
import {
    Equipment_CategoryFormFields,
    Equipment_CategoryRelated
} from "@containers/facility/Equipment_Category/Equipment_CategoryFormFields";

const EQUIPMENT_CATEGORY_MOBILE_EXCLUDE_KEYS = [
    "name",
    "life_expectancy",
    "modified_date",
];

const EQUIPMENT_CATEGORY_MOBILE_INCLUDE_KEYS = [
    "spec_schema",
    "comment",
];

const formatEquipmentCategoryDate = (value) => {
    const date = moment(value);
    return value && date.isValid() ? date.format("YYYY-MM-DD HH:mm") : "-";
};

const renderEquipmentCategoryMobileHeader = (record, navigateToDetail) => (
    <div className="equipment-category-mobile-card">
        <div className="equipment-category-mobile-card-main">
            <span
                className="equipment-category-mobile-card-title"
                title={record.name || ""}
                onClick={(event) => {
                    event.stopPropagation();
                    navigateToDetail(record.id);
                }}
            >
                {record.name || "-"}
            </span>
            <span className="equipment-category-mobile-card-date">
                {formatEquipmentCategoryDate(record.modified_date)}
            </span>
        </div>
        <div className="equipment-category-mobile-card-meta">
            <span className="equipment-category-mobile-card-label">Life Expectancy</span>
            <span className="equipment-category-mobile-card-value">
                {record.life_expectancy ?? "-"}
                {record.life_expectancy != null && record.life_expectancy !== "" ? " years" : ""}
            </span>
        </div>
    </div>
);

class Equipment_Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            templatePickerOpen: false,
            templateOptions: [],
            templateOptionsLoading: false,
            selectedTemplateId: "default",
        }
    }

    handleCreateEquipmentCategory = (body) => {
        return api.createEquipmentCategory(body).then(
            response => {
                console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteEquipmentCategory = (id) => {
        return api.deleteEquipmentCategory(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        return api.bulkEquipmentCategoryInsert(body).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        return api.bulkDeleteEquipmentCategory(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        return api.editEquipmentCategory(key, row).then(
            response => {

                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {
        console.log('triggered', query)
        this.setState({
            isLoading: true
        })
        return api.filterEquipmentCategory(query).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                }
            }
        ).catch(error => (
            error
        ));
    }

    getEquipmentCategory = (data) => {
        this.setState({
            data,
            isLoading: false,
        })
        this.props.setEquipmentCategorySuccess(data)
    }

    fetchTemplateOptions = async () => {
        try {
            console.log("[EquipmentCategoryTemplatePicker] fetching templates");
            const response = await api.filterEquipmentCategoryTemplates("page=1&page_size=999");
            console.log("[EquipmentCategoryTemplatePicker] raw response", response);
            if (!response?.data) {
                console.warn("[EquipmentCategoryTemplatePicker] response.data is empty", response);
                return [];
            }
            const results = Array.isArray(response.data?.results)
                ? response.data.results
                : Array.isArray(response.data)
                    ? response.data
                    : [];
            console.log("[EquipmentCategoryTemplatePicker] parsed results", {
                isResultsArray: Array.isArray(response.data?.results),
                isDataArray: Array.isArray(response.data),
                count: results.length,
                results,
            });
            const options = results.filter((template) => template && template.id).map((template) => ({
                label: template.name || `Template ${template.id}`,
                value: String(template.id),
            }));
            console.log("[EquipmentCategoryTemplatePicker] mapped options", options);
            return options;
        } catch (error) {
            console.error("[EquipmentCategoryTemplatePicker] fetch failed", error);
            message.error("Failed to load equipment category templates");
            return [];
        }
    }

    onNew = async () => {
        console.log("[EquipmentCategoryTemplatePicker] Create clicked");
        this.setState({
            templatePickerOpen: true,
            selectedTemplateId: "default",
            templateOptions: [],
            templateOptionsLoading: true,
        }, () => {
            console.log("[EquipmentCategoryTemplatePicker] picker opened", this.state);
        });
        const templateOptions = await this.fetchTemplateOptions();
        this.setState({
            templatePickerOpen: true,
            templateOptions,
            templateOptionsLoading: false,
        }, () => {
            console.log("[EquipmentCategoryTemplatePicker] options committed to state", {
                templateOptions: this.state.templateOptions,
                selectOptions: [
                    { label: "Default", value: "default" },
                    ...this.state.templateOptions,
                ],
            });
        });
    }

    handleApplyTemplate = () => {
        const { selectedTemplateId } = this.state;
        const path = selectedTemplateId === "default"
            ? "/admin/create-equipment-category"
            : `/admin/create-equipment-category?templateId=${selectedTemplateId}`;
        console.log("[EquipmentCategoryTemplatePicker] Apply clicked", {
            selectedTemplateId,
            path,
        });
        this.setState({ templatePickerOpen: false });
        this.props.navigateAndCloseTabs(path, "/admin/create-equipment-category");
    }

    render() {
        const templateSelectOptions = [
            { label: "Default", value: "default" },
            ...this.state.templateOptions,
        ];
        const templateSelectProps = {
            style: { width: "100%" },
            value: this.state.selectedTemplateId,
            placeholder: "Select equipment category template",
            loading: this.state.templateOptionsLoading,
            disabled: this.state.templateOptionsLoading,
            options: templateSelectOptions,
            onChange: (value, option) => {
                console.log("[EquipmentCategoryTemplatePicker] selection changed", {
                    value,
                    option,
                    availableOptions: templateSelectOptions,
                });
                this.setState({ selectedTemplateId: value });
            },
        };

        return (

            <div className="m-5">
                <Modal
                    title="Select Equipment Category Template"
                    open={this.state.templatePickerOpen}
                    onOk={this.handleApplyTemplate}
                    onCancel={() => this.setState({ templatePickerOpen: false })}
                    okText="Apply"
                    cancelText="Cancel"
                    confirmLoading={this.state.templateOptionsLoading}
                    okButtonProps={{ disabled: this.state.templateOptionsLoading }}
                    destroyOnClose
                >
                    {this.props.isPC ? (
                        <AntdSelect
                            {...templateSelectProps}
                            onDropdownVisibleChange={(open) => {
                                console.log("[EquipmentCategoryTemplatePicker] desktop dropdown visibility", {
                                    open,
                                    options: templateSelectOptions,
                                });
                            }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        />
                    ) : (
                        <Select
                            {...templateSelectProps}
                            popupTitle="Select Equipment Category Template"
                            forceMobileDrawer
                        />
                    )}
                </Modal>
                <EditableTable
                    columns={Equipment_CategoryColumns}
                    data={this.state.data}
                    columnProps={Equipment_CategoryProps}
                    formFields={Equipment_CategoryFormFields}
                    formRelated={Equipment_CategoryRelated}
                    getRecord={this.getEquipmentCategory}
                    createRecords={this.handleCreateEquipmentCategory}
                    deleteRecord={this.handleDeleteEquipmentCategory}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    relatedList={this.props.relatedList}
                    hide_date={true}
                    hide_imports={true}
                    isRowClickable={false}
                    hide_search={true}
                    isChat={false}
                    isRelated={false}
                    isAttachments={false}
                    hid_new={!this.props.canWrite}
                    onNew={this.onNew}
                    canDelete={this.props.canFullAccess}
                    mobileCardHeaderRender={(record) => renderEquipmentCategoryMobileHeader(
                        record,
                        (id) => this.props.navigateAndCloseTabs(
                            `/admin/equipment-category-detail/${id}`,
                            "/admin/equipment-category-detail/"
                        )
                    )}
                    mobileExpandedExcludeKeys={EQUIPMENT_CATEGORY_MOBILE_EXCLUDE_KEYS}
                    mobileExpandedIncludeKeys={EQUIPMENT_CATEGORY_MOBILE_INCLUDE_KEYS}
                    onDoubleClick={(record) => {
                        this.props.navigateAndCloseTabs(`/admin/equipment-category-detail/${record.id}`, '/admin/equipment-category-detail/');
                    }}
                />
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        Facility: _.get(state.Facility, 'data'),
        isPC: _.get(state.App, 'isPC', true),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setEquipmentCategorySuccess: (e) => dispatch(actions.EquipmentCategorySuccess(e)),
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const canWrite = useAuth('equipmentCategory', AUTH_LEVEL.WRITE);
        const canFullAccess = useAuth('equipmentCategory', AUTH_LEVEL.FULL_ACCESS);
        const { navigateAndCloseTabs } = useSmartNavigate();
        return <Component {...props} canWrite={canWrite} canFullAccess={canFullAccess} navigateAndCloseTabs={navigateAndCloseTabs} />
    }
    return NewComponent;
}

export default withHooks(connect(
    mapStateToProps,
    mapDispatchToProps
)(Equipment_Category));
